<template>
  <div class="product-wrapper">
    <div class="product-name">{{ name }}</div>
    <div class="relative">
      <img
        :src="currentImage"
        class="product-image"
        :key="currentModelId"
      />

      <img
        v-if="hasSwipeLeft"
        class="control control--left"
        src="/product-advisor/images/icons/chevron-left.svg"
        @click.prevent="$emit('swipeLeft')"
      />
      <img
        v-if="hasSwipeRight"
        class="control control--right"
        src="/product-advisor/images/icons/chevron-right.svg"
        @click.prevent="$emit('swipeRight')"
      />
    </div>
    <div class="mt-4 flex flex-col items-center">
      <div class="mt-2 text-lg">{{ currentPrice }}</div>
      <div class="mt-2 flex">
        <color
          class="mx-2"
          @select="selectColor"
          :color1="color.color1"
          :color2="color.color2"
          :model-id="color.modelId"
          :key="color.color1 + '-' + color.color2"
          :selected="color.modelId === currentModelId"
          v-for="color in colors"
        />
      </div>
      <button
        @click.prevent="addToCart"
        class="mt-3 button button-success w-full button-text-small w-3/4 bg-ctm-button">{{ $t('resultScreen.into_cart') }}</button>
      <button
        @click.prevent="details"
        class="button button-outline w-full button-text-small w-3/4 mt-1">{{ $t('resultScreen.details') }}</button>
    </div>
    <div class="mt-4">
      <div class="advice">{{ reason }}</div>
      <div class="customer">
<!--        <img-->
<!--          class="customer-image"-->
<!--          :src="currentAdvisorPath">-->
        <div class="name">{{ $t('resultScreen.' + advisorIcon + '_name') }}, {{ $t('resultScreen.' + advisorIcon) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    props: [
      'name',
      'link',
      'reason',
      'product',
      'hasSwipeLeft',
      'hasSwipeRight',
    ],
    computed: {
      ...mapGetters({
        advisor: 'advisor',
        advisorIcon: 'advisorIcon',
        advisorIcons: 'advisorIcons',
      }),
      currentAdvisorPath() {
        let currentAdvisor = this.advisorIcon
        if (currentAdvisor) {
          let ca = this.advisorIcons.find(advisor => advisor.id === currentAdvisor)
          if (ca) {
            return ca.icon
          }
        }
      },
      colors() {
        if (this.product) {
          let activeColors = JSON.parse(this.product?.calculatedActiveColors);
          let activeChildren = this.product?.children?.filter(child => activeColors.includes(child.identifier));

          return activeChildren
            .map(c => {
              return {
                hexCodes: JSON.parse(c.calculatedHexCodes),
                modelId: c.identifier,
              }
            })
            .map(c => {
              return {
                modelId: c.modelId,
                color1: c.hexCodes.hex_code_1,
                color2: c.hexCodes.hex_code_2,
              }
            })
        }
      },
      currentPrice() {
        let calculatedPrices = this.product?.children
          ?.find(c => c.identifier === this.currentModelId)
          ?.children[0]
          ?.calculatedPrices
        if (calculatedPrices) {
          calculatedPrices = JSON.parse(calculatedPrices)
          let calculatedPrice = calculatedPrices.find(cp => ('' + cp.countryISO).toLowerCase() === this.$i18n.locale)
          if (calculatedPrice && calculatedPrice.retailPrice) {
            return `${calculatedPrice.retailPrice}`.split('.').join(',') + ' ' + calculatedPrice.currency
          }
        }
      },
      currentAddToCartLink() {
        let calculatedAddToCartLink = this.product?.children
        ?.find(c => c.identifier === this.currentModelId)
          ?.children[0]
          ?.calculatedAddToCartLink
        if (calculatedAddToCartLink) {
          calculatedAddToCartLink = JSON.parse(calculatedAddToCartLink)
          return process.env.VUE_APP_BASE_URL + calculatedAddToCartLink?.find(l => l.indexOf(this.$i18n.locale + '-' + this.$i18n.locale) > -1)
        }
      },
      currentArticleId() {
        let url = new URL(this.currentAddToCartLink);
        return url.searchParams.get("articleId")
      },
      currentImage() {
        let calculatedImageLink = this.product?.children
          ?.find(c => c.identifier === this.currentModelId)
          ?.calculatedImageLink
        if (calculatedImageLink) {
          calculatedImageLink = JSON.parse(calculatedImageLink)
          if (calculatedImageLink && calculatedImageLink[0]) {
            return process.env.VUE_APP_BASE_URL + calculatedImageLink[0]
          }
        }
      }
    },
    data() {
      return {
        currentModelId: null,
      }
    },
    methods: {
      addToCart() {
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
                "Sec-Fetch-Mode": "cors",
                "X-Requested-With": "XMLHttpRequest"
            },
            body: 'articleId=' + this.currentArticleId
        };
        fetch(process.env.VUE_APP_BASE_URL + '/' + this.$i18n.locale + '-' + this.$i18n.locale + process.env.VUE_APP_CART_URL + '/add-to-cart', requestOptions)
            .then(
                this.$emit('add', this.currentModelId)
            )
            .catch(error => {
                this.errorMessage = error;
                console.error('There was an error!', error);
            });
      },
      details() {
        window.open(process.env.VUE_APP_BASE_URL + this.link, '_blank')
      },
      selectColor($event) {
        this.currentModelId = $event
      }
    },
    watch: {
      product: {
        deep: true,
        immediate: true,
        handler() {
          this.currentModelId = JSON.parse(this.product?.calculatedActiveColors)[0]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .product-wrapper {
    @apply
      px-2
      pb-4
      w-full
      flex-shrink-0;

    .product-image {
      @apply
        mt-4
        w-full
        h-full
        max-w-32
        max-h-full
        mx-auto
        select-none;
    }

    .control {
      @apply
        top-14
        absolute
        cursor-pointer;
    }

    .control--left {
      @apply
        left-2;
    }

    .control--right {
      @apply
        right-2;
    }

    .product-name {
      @apply
        text-xs
        uppercase
        text-center
        font-semibold
        text-ctm-primary;
    }

    .advice {
      @apply
        w-2/3
        mx-auto
        text-sm
        text-ctm-primary;
    }

    .customer {
      @apply
        mt-3
        flex
        w-full
        justify-center;

      .customer-image {
        @apply
          mr-2
          w-10
          h-10
          object-cover;
      }

      .name {
        @apply
          text-xs
          capitalize;
      }
    }
  }
</style>